import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    display: flex;
    height: 100%;
    width: 100%;
    padding: 43px 24px;
    flex-direction: column;
  `,
  header: ({ theme }) => css`
    margin-bottom: 12px;
    color: ${theme.colors.neutral.variant[70]};
  `,
  icon: css`
    vertical-align: middle;
    margin-right: 8px;
  `,
  textAreaWrapper: ({ theme }) => css`
    display: flex;
    flex-direction: column;
    border-top: solid 1px ${theme.colors.neutral.variant[30]};
    padding: 12px;
    height: 100%;
    width: 100%;
  `,
  suggestionBox: ({ theme }) => css`
    display: flex;
    width: 100%;
    height: 100%;

    background: ${theme.colors.neutral.variant[10]};
    border-radius: 12px;
    padding: 12px;
    margin-bottom: 16px;
    position: relative;
    flex-direction: column;

    gap: 12px;
  `,
  suggestionBoxEditing: ({ theme }) => css`
    color: ${theme.colors.neutral.variant[40]};
    padding: 0;
    background: ${theme.colors.neutral.variant[0]};

    & > div {
      border-color: ${theme.colors.neutral.variant[30]};
    }
  `,
  saveButtonWrapper: css`
    display: flex;
    justify-content: flex-end;
    margin-top: auto;
    gap: 14px;
  `,
  textArea: css`
    display: flex;
    height: 100%;
    flex-grow: 1;
  `,
} satisfies Styles<null>;

export const useStyles = withStyles(styles);
